<template>
  <BobProPage
    :columns="columns"
    :table-config="tableConfig"
    @refresh="onRefresh"
  />
</template>

<script>
import { defineComponent, computed } from 'vue'
import { FindMemberCustomProfile, GetMemberCustomProfileCount } from '@/api/memberCustomProfile'
import BobProPage from '@/components/BobProPage.vue'
import { get } from 'lodash'
import { useBobProPage } from '@/use/useBobProPage'
import { i18n } from '@/plugins/i18n/i18n'

export default defineComponent({
  name: 'MemberCustomProfileTab',
  components: {
    BobProPage,
  },
  props: {
    type: {
      type: String,
      default: 'foodpanda',
    },
    memberId: {
      type: String,
      required: true,
    },
  },
  setup (props) {
    const { onRefresh } = useBobProPage()
    const tableConfig = computed(() => ({
      pagination: {
        enabled: true,
        pageLimit: 10,
        pageSizes: [10, 20, 50],
      },
      apis: {
        get: FindMemberCustomProfile,
        count: GetMemberCustomProfileCount,
        getPayload: (filters) => ({
          code: filters.code || undefined,
          name: filters.name || undefined,
          type: props.type,
          MemberId: props.memberId,
        }),
      },
      filters: [
        {
          key: 'code',
          component: () => import('@/components/Input/SearchTextInput.vue'),
          props: (filters) => ({
            clearable: true,
            placeholder: i18n.t('member.tab.memberCustomProfile.searchCode'),
            value: filters.code,
          }),
          on: (filters) => ({
            'update:value': (value) => {
              filters.code = value
            },
          }),
        },
        {
          key: 'name',
          component: () => import('@/components/Input/SearchTextInput.vue'),
          props: (filters) => ({
            clearable: true,
            placeholder: i18n.t('member.tab.memberCustomProfile.searchName'),
            value: filters.name,
          }),
          on: (filters) => ({
            'update:value': (value) => {
              filters.name = value
            },
          }),
        },
      ],
    }))

    const columns = [
      {
        prop: 'info.foodpandaRestaurant.code',
        label: i18n.t('member.tab.memberCustomProfile.restaurantCode'),
        align: 'center',
        component: 'div',
        render: (row) => get(row, 'info.foodpandaRestaurant.code', ''),
      },
      {
        prop: 'info.foodpandaRestaurant.name',
        label: i18n.t('member.tab.memberCustomProfile.restaurantName'),
        align: 'center',
        component: 'div',
        render: (row) => get(row, 'info.foodpandaRestaurant.name', ''),
      },
      {
        prop: 'info.foodpandaRestaurant.contactName',
        label: i18n.t('member.tab.memberCustomProfile.contactName'),
        align: 'center',
        component: 'div',
        render: (row) => get(row, 'info.foodpandaRestaurant.contactName', ''),
      },
      {
        prop: 'info.foodpandaRestaurant.contactMobile',
        label: i18n.t('member.tab.memberCustomProfile.contactMobile'),
        align: 'center',
        component: 'div',
        render: (row) => get(row, 'info.foodpandaRestaurant.contactMobile', ''),
      },
      {
        prop: 'info.foodpandaRestaurant.address',
        label: i18n.t('member.tab.memberCustomProfile.restaurantAddress'),
        align: 'center',
        component: 'div',
        render: (row) => get(row, 'info.foodpandaRestaurant.address', ''),
      },
      {
        prop: 'info.foodpandaRestaurant.phone',
        label: i18n.t('member.tab.memberCustomProfile.restaurantPhone'),
        align: 'center',
        component: 'div',
        render: (row) => get(row, 'info.foodpandaRestaurant.phone', ''),
      },
    ]

    return {
      tableConfig,
      columns,
      onRefresh,
    }
  },
})
</script>

<style lang="scss" scoped></style>
